"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseAmendment(tx) {
    return {
        amendment: tx.Amendment
    };
}
exports.default = parseAmendment;
//# sourceMappingURL=amendment.js.map